import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ProductModuleState } from '../../models/product.model';

export const getProductModuleState = createFeatureSelector<ProductModuleState>('productModule');

export const getProducts = createSelector(getProductModuleState, (state) => state.products);

export const getCustomerProducts = createSelector(
  getProductModuleState,
  (state) => state.customerProducts,
);

export const getSelectedLocations = createSelector(
  getProductModuleState,
  (state) => state.locations,
);

export const getSelectedProduct = createSelector(
  getProductModuleState,
  (state) => state.selectedProduct,
);

export const getSelectedProductCountry = createSelector(
  getProductModuleState,
  (state) => state.selectedCountry,
);
